<template>
    <div class="tab-container">
      <div ref="tabWrapper"  :class="{'flexSb': flexStyle}" class="tab-wrapper notScroll">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab-item"
          
          :class="{ active: activeIndex === index , 'paddingNone': flexStyle}"
          @click="handleTabClick(index,tab)"
          ref="tabItems"
        >
        <div class="tabTxt" :class="{ underLine: activeIndex === index }">
            {{ tab && tab.name ? tab.name : tab }}
        </div>
         
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props:{
      flexStyle:{
        type:Boolean,
        default:false
      },
        tabs:{
            type:Array,
            default:[]
        }  
    },
    data() {
      return {
        activeIndex: 0,
      };
    },
    methods: {
      handleTabClick(index,tab) {
        this.activeIndex = index;
        this.$emit("choseTabItemCb", {index:this.activeIndex,id:tab?.id})
        this.handleScroll();
      },
      handleScroll() {
        const tabWrapper = this.$refs.tabWrapper;
        const tabItems = this.$refs.tabItems;
        const wrapperWidth = tabWrapper.offsetWidth;
  
        let scrollLeft = tabWrapper.scrollLeft; // 当前滚动位置
        let currentTab = tabItems[this.activeIndex];
  
        if (currentTab) {
          const currentLeft = currentTab.offsetLeft;
          const currentRight = currentTab.offsetLeft + currentTab.offsetWidth;
  
          // 检查是否需要提前滚动两格
          if (currentLeft < scrollLeft + tabItems[0].offsetWidth * 2) {
            // 靠近左边，向左滚动
            tabWrapper.scrollTo({
              left: Math.max(0, currentLeft - tabItems[0].offsetWidth * 2),
              behavior: "smooth",
            });
          } else if (currentRight > scrollLeft + wrapperWidth - tabItems[0].offsetWidth * 2) {
            // 靠近右边，向右滚动
            tabWrapper.scrollTo({
              left: Math.min(
                tabWrapper.scrollWidth,
                currentRight - wrapperWidth + tabItems[0].offsetWidth * 2
              ),
              behavior: "smooth",
            });
          }
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .tab-container {
    overflow: hidden;
    width: 100%;
   
  }
  
  .tab-wrapper {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
    height: 42px;
   
  }
  
  .tab-item {
    padding: 0 16px;
    font-size: 16px;
    height: 42px;
    line-height: 42px;
    color: #9F9F9F;
    cursor: pointer;
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .underLine{
    border-bottom: 2px solid #0059A3;
  }
  
  .tab-item.active {
    color: #0059A3;
    font-weight: bold;
    line-height: 32px;
    position: relative;
    top: 2px;
  }
  .flexSb{
    justify-content: space-around;
  }
  .paddingNone{
    padding: 0;
  }
  </style>
  